module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-pt-br.9c3cc54b71e9a3d9de54.svg";